export const ADMIN_SECURITY_CONFIGURATION_ANALYTICS_SOURCE = 'securityConfiguration';

export const EXTERNAL_LINKS_LEARN_MORE_LINK =
	'https://support.atlassian.com/confluence-cloud/docs/hide-external-links-from-search-engines/';

export const PRIVACY_IN_ANALYTICS_LINK =
	'https://support.atlassian.com/confluence-cloud/docs/turn-on-privacy-mode-for-analytics-data/';

export const MAX_SAFE_JAVA_INTEGER = 2147483647;
